import { SystemStyleObject } from '@chakra-ui/react'

import { tokenVar } from '../../theme/tokenVar'
import type { ColorScheme } from '../../types'

export type { ColorScheme }

/** `alarm` renders the whole row in the error status color. */
export type TraceLogEventVariant = 'default' | 'alarm'

const tokens = {
  dark: {
    border: 'border.subtle',
    title: 'text.primary',
    secondary: 'text.secondary',
    alarm: 'status.error-text',
  },
  light: {
    border: 'light.border.subtle',
    title: 'light.text.primary',
    secondary: 'light.text.secondary',
    alarm: 'light.status.error-text',
  },
} as const

export const traceLogEventStyles = (
  variant: TraceLogEventVariant,
  colorScheme: ColorScheme = 'dark'
): Record<string, SystemStyleObject> => {
  const t = tokens[colorScheme]
  const isAlarm = variant === 'alarm'

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      p: '12px',
      borderTop: '1px solid',
      borderTopColor: t.border,
      w: 'full',
    },
    titleRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      w: 'full',
    },
    title: {
      textStyle: 'caption-medium',
      color: isAlarm ? t.alarm : t.title,
      minW: 0,
    },
    timestamp: {
      textStyle: 'accent',
      textTransform: 'uppercase',
      color: isAlarm ? t.alarm : t.secondary,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    detailRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    detailLabel: {
      textStyle: 'small-body',
      color: isAlarm ? t.alarm : t.secondary,
    },
    accentLabel: {
      textStyle: 'accent',
      textTransform: 'uppercase',
      color: isAlarm ? t.alarm : t.secondary,
    },
  }
}

// Icons take a raw CSS color, not a Chakra token, so resolve the semantic
// through its CSS variable.
export const traceLogEventIconColor = (
  variant: TraceLogEventVariant,
  colorScheme: ColorScheme = 'dark'
): string =>
  tokenVar(
    `colors.${tokens[colorScheme][variant === 'alarm' ? 'alarm' : 'secondary']}`
  )
